import { Row, Col } from 'antd';

import { formatMDY } from 'utils/formatDate';
import { get } from 'lodash';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const AssetTileFooter = (props) => {
  const { intl, dataDetail } = props;

  const loadedDate = get(dataDetail, 'loadedDate', '');
  const lastUpdated = get(dataDetail, 'lastUpdated', '');

  return (
    <Row className='asset-tile__footer' justify='center' align='middle'>
      <Col flex='auto'>
        <Row>
          <Col style={{ width: '85px', color: '#000' }}>
            {intl.formatMessage({
              id: 'Taco.common.components.assetList.lastUpdated',
            })}{' '}
          </Col>
          <Col>{lastUpdated && formatMDY(lastUpdated)} </Col>
        </Row>
        <Row>
          <Col style={{ width: '85px', color: '#000' }}>
            {intl.formatMessage({
              id: 'Taco.common.components.assetList.imageDate',
            })}{' '}
          </Col>
          <Col> {loadedDate && formatMDY(loadedDate)}</Col>
        </Row>
      </Col>
    </Row>
  );
};

AssetTileFooter.propTypes = {
  loadedDate: PropTypes.string,
  lastUpdate: PropTypes.string,
};

export default injectIntl(AssetTileFooter);
